require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./quarterly-newsletter-september.json") })
        }
      }, "path---quarterly-newsletter-september");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---quarterly-newsletter-september!./.cache/json/quarterly-newsletter-september.json
// module id = 1179
// module chunks = 231608221292675